import { useEffect } from "react";


export function useScrollFadeIn(targetClass: string, deps: React.DependencyList = [], delay = 150) {
    useEffect(() => {
        const elements = Array.from(
            document.querySelectorAll(`.${targetClass}`)
        );

        if (!elements.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // const index = elements.indexOf(entry.target as Element);

                        setTimeout(() => {
                            (entry.target as HTMLElement).classList.add("visible");
                        // }, index * delay);
                        }, delay);

                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, deps); // ←依存に入れる
}
